import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

export default function DualResultView() {
  // route: /dual-results/view/:testId/:id
  const { testId, id } = useParams();

  const lang = useUserLanguage();
  const { translations } = useTranslations(lang);
  const t = (k, d = "") => translations[k] || d;
 const [summary, setSummary] = useState(""); 
  const [loading, setLoading] = useState(true);
  const [testName, setTestName] = useState("");
  const [title, setTitle] = useState("");
  const [blocks, setBlocks] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        if (!testId || !id) return;

        const token = localStorage.getItem("admin_token");
        const headers = { Authorization: `Bearer ${token}` };

        // Test adı
        const testRes = await axios.get(`/api/tests/${testId}`, { headers });
        const testData = testRes.data?.data || testRes.data;
        setTestName(testData?.name || "");

        // Kayıt
        const rowRes = await axios.get(
          `/api/dual-results/tests/${testId}/dual-results/${id}`,
          { headers }
        );
        const row = rowRes.data;
        setTitle(row?.title || "");
        setSummary(row?.summary || ""); 
        setBlocks(Array.isArray(row?.blocks) ? row.blocks : []);
      } catch (err) {
        console.error("❌ DualResultView fetch error:", err);
        toast.error(t("LOAD_FAILED", "Kayıt yüklenemedi"));
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testId, id]);

  if (loading) {
    return (
      <div className="container my-4">
        <p>{t("LOADING", "Yükleniyor…")}</p>
      </div>
    );
  }

  return (
    <div className="container my-4">
      {/* Üst başlık ve aksiyonlar */}
<div className="d-flex justify-content-between align-items-center mb-3">
  <div className="small text-muted">
    Test: <strong>{testName || `#${testId}`}</strong>
    {title && (
      <>
        {" · "}Detay: <strong>{title}</strong>
      </>
    )}
  </div>
  <Link to={`/test/dual-results/${testId}`} className="btn btn-outline-secondary btn-sm">
    {t("BACK_TO_LIST", "Listeye Dön")}
  </Link>
</div>

       {/* Özet Bilgi (varsa) */}
      {summary && (
        <div className="card mb-4">
          <div className="card-header">
            <strong>{t("SUMMARY", "Özet Bilgi")}</strong>
          </div>
          <div className="card-body">
            <div
              className="rich-html"
              dangerouslySetInnerHTML={{ __html: summary }}
            />
          </div>
        </div>
      )}

      {/* İçerik blokları */}
      {(!blocks || blocks.length === 0) ? (
        <div className="alert alert-warning">{t("NO_CONTENT", "Bu kayıtta içerik bulunmuyor.")}</div>
      ) : (
        <div className="vstack gap-4">
          {blocks.map((blk, idx) => (
            <div key={idx} className="card">
              <div className="card-header">
                <strong>{t("EDITOR_PAIR", "Editör Seti")} #{idx + 1}</strong>
              </div>
              <div className="card-body">
                <div className="row g-4">
                  <div className="col-12 col-lg-6">
                    <h6 className="fw-bold mb-2">{t("MAIN_EDITOR", "Ana Açıklama")}</h6>
                    <div
                      className="border rounded p-3"
                      // HTML'i olduğu gibi gösteriyoruz
                      dangerouslySetInnerHTML={{ __html: blk?.main_html || "" }}
                    />
                  </div>
                  <div className="col-12 col-lg-6">
                    <h6 className="fw-bold mb-2">{t("SIDE_EDITOR", "Yan Açıklama")}</h6>
                    <div
                      className="border rounded p-3"
                      dangerouslySetInnerHTML={{ __html: blk?.side_html || "" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
